var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{directives:[{name:"resize",rawName:"v-resize",value:({ checkOrigin: false, log: !!_vm.$config.local }),expression:"{ checkOrigin: false, log: !!$config.local }"}],staticClass:"ypq-site--iframe",attrs:{"frameborder":"0","src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }